import { render, staticRenderFns } from "./PayrollMovementList.vue?vue&type=template&id=0381ec6f&scoped=true"
import script from "./PayrollMovementList.vue?vue&type=script&lang=js"
export * from "./PayrollMovementList.vue?vue&type=script&lang=js"
import style0 from "./PayrollMovementList.vue?vue&type=style&index=0&id=0381ec6f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0381ec6f",
  null
  
)

export default component.exports